import { classnames } from '@aibees/shared/utils';
import { CircularProgress, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { LoadingSpinnerProps as Props } from './types';

export const LoadingSpinner = memo(
  ({ className, textIncluded, textColor, circularProgressColor }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('LoadingSpinner', className)}
        sx={SX.root}
      >
        <CircularProgress
          size={18}
          color={circularProgressColor ?? 'primary'}
        />
        {textIncluded && (
          <Typography
            variant="body4"
            fontWeight={500}
            color={textColor ?? 'primary.500'}
          >
            Loading...
          </Typography>
        )}
      </Styled.Wrapper>
    );
  }
);

LoadingSpinner.displayName = 'LoadingSpinner';
